// extracted by mini-css-extract-plugin
module.exports = {"itemsContact":"Contact_itemsContact__33WuT","contactP":"Contact_contactP__3FmVn","icon":"Contact_icon__dl3vW"};